<!-- Desktop Tires Header -->
<app-header-sidebar-menu (sidebarState)="onSidebarStateChange($event)"></app-header-sidebar-menu>

<div class=" header-wrapper d-none d-md-block normal-header" [class.show]="!isSticky">
  <app-header-promotion [custom_ticker]="custom_ticker"></app-header-promotion>
  <div class="row align-items-center mb-2 d-flex justify-content-center">
    <div class="col-6 col-sm-6 col-md-12 col-lg-2 col-xl-2 col-xxl-2">
      <div class="d-flex justify-content-center">
        <app-header-logo *ngIf="showLogo"></app-header-logo>
      </div>
    </div>
    <div class="col-sm-12 col-md-12 col-lg-10 col-xl-8 col-xxl-8">
      <div class="row justify-content-md-center">
        <div class="col-10 col-lg-12 col-xl-12">
          <div class="d-flex align-items-center justify-content-lg-end justify-content-md-center heri-line-col">
            <app-header-nav *ngIf="showFirstRowHeader"></app-header-nav>
          </div>
        </div>
      </div>
      <div class="row align-items-center">
          <div class="col-12 col-md-8 col-lg-7 col-xl-8 cust-left pe-0" [ngClass]="{ 'sticky-l-width': isWishlist}">
              <app-header-search></app-header-search>
          </div>
          <div class="col-4 col-md-4 col-lg-5 col-xl-4 cust-right pe-0 ps-0" [ngClass]="{ 'sticky-r-width': isWishlist}">
              <div class="d-flex justify-content-evenly wrap-app gap-lg-3 gap-xxl-0 align-items-center p-0">
                  <app-shop-by-vehicle *ngIf="isSearchByVehicleDisabled"></app-shop-by-vehicle>
                  <app-header-cart-section *ngIf="showSecondRowHeader"></app-header-cart-section>
              </div>
          </div>
      </div>
    </div>
    <!--<div class="col-sm-12 col-md-2 col-lg-2 col-xl-2 col-xxl-2">
      <app-header-contact-us-section></app-header-contact-us-section>
      <app-header-my-garage-section></app-header-my-garage-section>
    </div>-->
  </div>
  <div class="row mt-3">
    <div class="col-12 cat-third-row">
      <div class="d-flex align-items-center justify-content-center justify-content-lg-center">
        <app-header-third-row></app-header-third-row>
      </div>
    </div>
  </div>
</div>

<!-- Sticky Header -->
<div class="sticky-header d-none d-md-block" [class.show]="isSticky">
  <div class="sticky-menu" [ngClass]="{ 'sticky-active': isSticky }">
    <app-header-sidebar-menu (sidebarState)="onSidebarStateChange($event)"></app-header-sidebar-menu>
  </div>
  <div class="header-wrapper py-3 mb-md-3 mb-lg-0">
    <div class="row px-3 justify-content-center align-items-center">
      <div class="col-md-12 col-lg-2 text-center text-lg-center logo-tabs d-flex justify-content-center pb-2  pb-lg-2"
        [routerLink]="'/'" (click)="onButtonClick()">
        <img *ngIf="showLogo" [src]="cdnImagePath + headerdata?.websiteHeader[firstObj + 2]?.desktop_logo" alt="Logo"
          class="img-fluid d-none d-md-block desktop-img cursor-pointer theme-stiky-logo" fetchpriority="high" width="276" height="48" />
      </div>
      <div class="col-md-12 col-lg-9">
        <div class="row align-items-center justify-content-center">
                    <div class="col-12 col-md-8 col-lg-7 col-xl-8 col-xxl-9 cust-left pe-0 " [ngClass]="{ 'sticky-l-width': isWishlist}">
                        <app-header-search></app-header-search>
                    </div>
                    <div class="col-4 col-md-4 col-lg-5 col-xl-4 col-xxl-3 cust-right ps-0" [ngClass]="{ 'sticky-r-width': isWishlist}">
                        <div class="d-flex justify-content-between justify-content-lg-evenly wrap-app align-items-center p-0">
                            <app-shop-by-vehicle *ngIf="isSearchByVehicleDisabled"></app-shop-by-vehicle>
                            <app-header-cart-section *ngIf="showSecondRowHeader"></app-header-cart-section>
                        </div>
                    </div>
                </div>
        </div>
      </div>
      <!-- <div class="col-3 col-lg-2">
                <app-header-my-garage-section></app-header-my-garage-section>
            </div>-->
    </div>
  </div>

<!-- Mobile Headeapp-header-mobile-menur -->
<div class="container d-md-none">
  <app-header-mobile-menu [headerSettings]="headerSettings" [custom_ticker]="custom_ticker"></app-header-mobile-menu>
</div>
<app-shopping-cart *ngIf="showCart"></app-shopping-cart>